import { sdkFactory as wixBillingV1TaxGroup_sdkFactory_taxGroups } from './src/billing-v1-tax-group.frontend';
import { sdkFactory as wixBillingV1TaxRegion_sdkFactory_taxRegions } from './src/billing-v1-tax-region.frontend';
import { sdkFactory as wixGatewaysBillingV1TaxCalculationGateway_sdkFactory_taxCalculation } from './src/gateways-billing-v1-tax-calculation-gateway.frontend';
export function sdkFactory(args) {
    return {
        taxGroups: wixBillingV1TaxGroup_sdkFactory_taxGroups(args),
        taxRegions: wixBillingV1TaxRegion_sdkFactory_taxRegions(args),
        taxCalculation: wixGatewaysBillingV1TaxCalculationGateway_sdkFactory_taxCalculation(args),
    };
}
//# sourceMappingURL=index.frontend.js.map